const LOADER_PATH = "/widget/v1/loader.js";

export function rewriteWidgetEmbedSnippet(snippet, brand) {
  if (typeof snippet !== "string" || snippet === "" || !brand || brand.id !== "settrhq") {
    return snippet;
  }

  const rawOrigin = typeof brand.canonicalOrigin === "string" ? brand.canonicalOrigin : "";
  if (rawOrigin === "") {
    return snippet;
  }

  const canonicalOrigin = rawOrigin.replace(/\/$/, "");
  return snippet.replace(/src="([^"]*)"/g, (match, value) => {
    const path = value.split("?")[0];
    if (!path.endsWith(LOADER_PATH)) {
      return match;
    }
    return `src="${canonicalOrigin}${LOADER_PATH}"`;
  });
}
